__turbopack_context__.v({
  "close": "xv_eBa_close",
  "closeIcon": "xv_eBa_closeIcon",
  "description": "xv_eBa_description",
  "dialog": "xv_eBa_dialog",
  "form": "xv_eBa_form",
  "formError": "xv_eBa_formError",
  "header": "xv_eBa_header",
  "headerTop": "xv_eBa_headerTop",
  "inner": "xv_eBa_inner",
  "modal": "xv_eBa_modal",
  "submitButton": "xv_eBa_submitButton",
  "title": "xv_eBa_title",
  "wrapper": "xv_eBa_wrapper",
});
